import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { spliceOut } from '../../../sharpr/util/spliceOut';

export function SettingsEmailDomainsRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SettingsEmailDomains', {
		url: '/admin/recipient_domains',
		controllerAs: 'vm',
		controller: SettingsEmailDomainsCtrl,
		templateUrl: '/ng/hub/Settings/EmailDomains/SettingsEmailDomainsCtrl.html?' + window.BUILD,
		permission: ['instance_settings'],
		resolve: {
			$title: () => 'Email Recipient Options',
			domains: ApiResourcify.endpoint('/emails/domains'),
		},
	});
}

export class SettingsEmailDomainsCtrl {
	constructor(Api, modal, domains) {
		'ngInject';
		this.modal = modal;
		this.domains = domains;
		this.Api = Api;
		this.newName = '';
		this.newNote = '';
	}

	addNew() {
		this.newName = this.newName.trim();
		this.newName = this.newName.toLocaleLowerCase();
		this.newName = this.newName.replace(/^@/, '');
		if (!this._isValid()) {
			this.modal.alert({ text: 'Name must be a valid domain such as "example.com".' });
			return;
		}
		const domain = {
			name: this.newName,
			note: this.newNote,
			permission: 'allow',
		};
		this.domains.push(domain);
		this.newName = '';
		this.newNote = '';
		this.Api.create('/emails/domains', domain).then(
			id => {
				if (id > 0) {
					domain.id = id;
				} else {
					this.modal.alert({ text: 'Error adding domain.' });
					spliceOut(this.domains, domain);
					this.newName = domain.name;
					this.newNote = domain.note;
				}
			},
			() => {}
		);
	}

	_isValid() {
		return this.newName.match(/.+\.[^.]+$/);
	}

	delete(domain) {
		this.modal.confirm({ text: 'Are you sure you want to delete this domain?' }).then(
			() => {
				spliceOut(this.domains, domain);
				this.Api.delete(`/emails/domains/${domain.id}`).then(
					() => {},
					() => {
						this.domains.push(domain);
						this.modal.alert({ text: 'Error deleting domain.' });
					}
				);
			},
			() => {}
		);
	}
}
